export default "__VITE_ASSET__Bp6N5AeQ__"